import * as React from 'react';
import { useState } from 'react';
import { EmailInput, ErrorText, FieldGroup, Link, PasswordInput, PillButton, Row, Stack } from 'library/ui';
import { useHistory } from 'react-router';
import { loginUser } from '../login/LoginMethod';
import { useUserContext } from 'UserContext';
import SignUpLoginTab from './SignUpLoginTab';
import SignUpLoginHeader from './SignUpLoginHeader';
import SignUpLoginContainer from './SignUpLoginContainer';

export default function LoginPage() {
    const history = useHistory();
    const { refreshUser } = useUserContext();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [, setIsUsernameError] = useState(false);
    const [, setIsPasswordError] = useState(false);
    const [isValidError, setIsValidError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    function handleLogin() {
        setIsLoading(true);
        loginUser(
            username,
            password,
            refreshUser,
            history,
            setIsUsernameError,
            setIsPasswordError,
            setIsValidError,
            () => setIsLoading(false),
        );
    }

    return (
        <SignUpLoginContainer>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleLogin();
                }}
            >
                <Row justify="center" fullWidth>
                    <Stack gap="lg" maxWidth="sm" fullWidth>
                        <Row justify="center" fullWidth>
                            <SignUpLoginTab />
                        </Row>
                        <SignUpLoginHeader>Login to the Childcare Program Portal</SignUpLoginHeader>
                        <Stack gap="md">
                            <FieldGroup label="Email">
                                <EmailInput
                                    id="login-email"
                                    value={username}
                                    onChange={(val) => setUsername(val)}
                                    fullWidth
                                />
                            </FieldGroup>
                            <FieldGroup label="Password">
                                <PasswordInput id="login-password" value={password} onChange={setPassword} fullWidth />
                            </FieldGroup>
                            {isValidError && <ErrorText>Either your username and password is incorrect</ErrorText>}
                        </Stack>

                        <Row>
                            <PillButton id="login-submit-button" type="submit" disabled={isLoading}>
                                Login
                            </PillButton>
                        </Row>

                        <Link to="/signin/change/password/verify">Forgot password?</Link>
                    </Stack>
                </Row>
            </form>
        </SignUpLoginContainer>
    );
}
